import axios, { CancelTokenSource } from 'axios'
import { LSKEY_TOKEN } from 'constants/app'
import ls from 'utils/ls'
import { toast } from 'react-toastify'
import { logout } from 'utils/logout'
import { NavigateFunction } from 'react-router-dom'

let navigate: NavigateFunction | null = null
let cognito: { signOut: () => void } | null = null

export function setLogoutContext(nav: NavigateFunction, cog: { signOut: () => void }) {
  navigate = nav
  cognito = cog
}

axios.defaults.baseURL = process.env.REACT_APP_API_URL
axios.defaults.headers = {
  'Content-Type': 'application/json',
}

const cancelSources: CancelTokenSource[] = []

axios.interceptors.request.use(
  (config) => {
    const cfg = config
    const isHeaderSet = cfg.headers.Authorization
    if (!isHeaderSet) {
      const token = ls.get(LSKEY_TOKEN)
      const bearer = `Bearer ${token}`
      if (token) cfg.headers.Authorization = bearer
    }

    const cs = axios.CancelToken.source()
    cancelSources.push(cs)

    cfg.cancelToken = cs.token

    return cfg
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const err = error?.response?.data || error

    if (err?.outcomeUserMessage?.includes('Access Token has expired')) {
      toast.error('Session expired, please login again.')
      if (navigate && cognito) {
        logout(navigate, cognito)
      }
    }

    return Promise.reject(err)
  }
)

const cancelAll = (): void => {
  cancelSources.forEach((source) => source.cancel('Request cancelled'))
}

const { get, post, put, patch, request, isCancel } = axios

const http = { get, post, put, patch, cancelAll, isCancel, request }

export default http
